import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipCompetenceDate = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FormLabel sx={{ color: 'text.primary' }}><b>Data de competência</b></FormLabel>
            <TooltipPopover>
                A data em que o serviço foi prestado, a venda realizada, ou a
                despesa incorrida. É o momento em que ocorre a geração da
                receita ou da despesa, independentemente de quando o dinheiro
                efetivamente entra ou sai da empresa.
                <br /> <br />
                <b>Exemplo:</b><br />
                Se um serviço foi prestado em Janeiro, mas o pagamento só foi
                ou será recebido em 'Fevereiro, a data de competência
                do serviço é Janeiro.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipCompetenceDate;